import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { FaEnvelope, FaPaperPlane } from 'react-icons/fa'
import utils from '../../modules/utils'
import UpdateFile from './UpdateFiles'

const BtnContatta = ({apiClient, email, onChangeEmail, idScheda}) => {  
  
  const [show, toggle]=useState(false)    
  const [messaggio, setMessaggio]=useState("")
  const [allegati, setAllegati] = useState([])  
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [disabled, setDisabled] = useState(false)

  const onSelectFiles = (allegati) => {    
    setAllegati([...allegati])
  }

  const onClose = () => {
    toggle(false)
  }

  const validazione = () => {         
    if(utils.validateEmail(email)===null){
      setInvalidEmail(true)
      return false;
    }
    return true;
  }

  const invia = () => {
    if(validazione()){     
      const params = {
        MESSAGGIO: messaggio,
        ALLEGATI: JSON.stringify(allegati),        
        EMAIL: email,
        ID_SCHEDA: idScheda
      }      
      apiClient.fnContattaStruttura(() => {                        
        setDisabled(true)
        toggle(false)          
      }, params);
    }    
  }

  const editEmail = (value) => {
    setInvalidEmail(false)
    onChangeEmail(value)
  }

  return (
    <>
      <Button variant="warning" size="lg" onClick={()=>toggle(true)} disabled={disabled} className='text-primary'><FaEnvelope /> Contatta la struttura</Button>
      <Modal show={show} size="lg" onHide={onClose} backdrop="static">
        <Modal.Header closeButton className='bg-warning text-dark'>
          <Modal.Title><FaEnvelope /> Contatta la struttura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          <Form.Group className='mb-4'>
            <Form.Label htmlFor="email">Email</Form.Label>
            <Form.Control id="email" 
                          type="email" 
                          value={email} 
                          onChange={e =>editEmail(e.target.value)}
                          isInvalid={invalidEmail}                          
                          >                            
            </Form.Control>
            <span>Indirizzo email presso cui essere ricontattato</span>
            <Form.Control.Feedback type="invalid">Fornire un indirizzo email valido</Form.Control.Feedback>
          </Form.Group>
          
          <Form.Group className='mb-4'>
            <Form.Label htmlFor="messaggio">Messaggio</Form.Label>
            <Form.Control id="messaggio" as="textarea" type="text" rows={3} value={messaggio} onChange={e => setMessaggio(e.target.value)} placeholder="Messaggio" />
          </Form.Group>

          <UpdateFile onSelectFiles={onSelectFiles}/>

        </Modal.Body>
        <Modal.Footer className="bg-light">
          <Button variant="outline-secondary" onClick={onClose}>
            Annullla
          </Button>        
          <Button variant="warning" onClick={invia} disabled={messaggio.trim()==="" || invalidEmail}>
            <FaPaperPlane /> Invia
          </Button>        
        </Modal.Footer>
      </Modal>      
    </>
  )
}

export default BtnContatta